<template>
  <div class="layout-container">
    <!-- 左侧菜单 -->
    <div class="sidebar-container" :class="{ 'is-collapse': isCollapse }">
      <Sidebar :is-collapse="isCollapse" @toggle="toggleCollapse" @login="handleLogin" />
    </div>

    <!-- 右侧主内容区 -->
    <div class="main-container" :class="{ 'is-collapse': isCollapse }">
      <!-- 内容区域 -->
      <div class="content-area">
        <router-view />
      </div>
    </div>

    <!-- 全局创建项目弹窗 -->
    <CreateProjectDialog />
    
    <!-- 算力弹窗 -->
    <CreditsDialog />
    
    <!-- 社群弹窗 -->
    <CommunityDialog />

    <!-- 个人信息弹窗 -->
    <ProfileDialog />

    <!-- 消息中心：侧栏列表 + 详情弹窗（详情 z-index 高于列表） -->
    <MessageCenter />
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import CreateProjectDialog from '@/components/CreateProjectDialog.vue'
import CreditsDialog from '@/components/CreditsDialog.vue'
import CommunityDialog from '@/components/CommunityDialog.vue'
import ProfileDialog from '@/components/ProfileDialog.vue'
import MessageCenter from '@/components/MessageCenter.vue'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    CreateProjectDialog,
    CreditsDialog,
    CommunityDialog,
    ProfileDialog,
    MessageCenter
  },
  provide() {
    return {
      setCollapse: this.setCollapse
    }
  },
  data() {
    return {
      isCollapse: false
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    setCollapse(value) {
      this.isCollapse = value
    },
    handleLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  display: flex;
  height: 100vh;
  background-color: #1a1a1a;
}

.sidebar-container {
  width: 200px;
  height: 100%;
  background-color: #1e1e1e;
  transition: width 0.3s ease;
  flex-shrink: 0;
  border-right: 1px solid #2d2d2d;

  &.is-collapse {
    width: 64px;
  }
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-area {
  flex: 1;
  overflow-y: auto;
  background-color: #1a1a1a;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #3d3d3d;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #1a1a1a;
  }
}
</style>
